import { useContainerWidth } from "@/hooks/useContainerWidth";

/** Below this much AVAILABLE width the panes stack (list → detail push flow):
 *  460px list + a detail pane that can still show a line item comfortably. */
const TWO_PANE_MIN_WIDTH = 820;

export interface InboxLayout {
  /** Callback ref for the inbox root (InboxSplitView attaches it). */
  ref: (node: HTMLDivElement | null) => void;
  /** Two panes side by side. True until the first measurement (see below). */
  twoPane: boolean;
  /** False until the inbox has been measured once. */
  measured: boolean;
}

/**
 * Shared two-pane inbox layout state (client Orders inbox + owner Client
 * messages inbox).
 */
export function useInboxLayout(): InboxLayout {
  // Two-pane vs single-pane keys off the space the inbox ACTUALLY has, not the
  // viewport: the app sidebar eats ~256px (and can be collapsed at runtime), so
  // a viewport media query put both panes up at ~830px wide and crushed the
  // detail pane to ~105px. `null` = not yet measured; assume two-pane so the
  // desktop case never flashes single-pane on first paint.
  const [ref, width] = useContainerWidth<HTMLDivElement>();
  const twoPane = width == null || width >= TWO_PANE_MIN_WIDTH;
  return { ref, twoPane, measured: width != null };
}
